import React from "react";
import { dashboardIcon } from "../../assets/img";

function Cancellation({ isDataAllCard }) {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "15px",
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "17px",
      lineHeight: "22px",
      color: "#222227",
    },
  };

  return (
    <>
      <div
        style={{
          padding: 18,
          background: "#FFFFFF",
          boxShadow: "0px 1px 10.4px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 20,
          }}
        >
          <p
            style={{
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "22px",
              display: "flex",
              alignItems: "center",
              color: "#222227",
            }}
          >
            Cancellation
          </p>
        </div>

        {/* SMALLER TOP CARDS */}
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* ---------- SMALLER CARD 1 ---------- */}
          <div
            style={{
              border: "1px solid #EEEEEE",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "12px",
              padding: "8px 14px",
              marginTop: "15px",
              width: "48%",
              minHeight: "90px",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#9ca3af",
                  margin: 0,
                }}
              >
                Total Cancellation Count
              </p>

              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#000000",
                  margin: 0,
                }}
              >
                {isDataAllCard?.cancellation?.total_cancellation_count &&
                  (
                    isDataAllCard?.cancellation?.total_cancellation_count || 0
                  ).toFixed(2)}
              </p>
            </div>

            <div>
              <div style={{ width: "26px", height: "26px" }}>
                <img
                  src={dashboardIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>

          {/* ---------- SMALLER CARD 2 ---------- */}
          <div
            style={{
              border: "1px solid #EEEEEE",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "12px",
              padding: "8px 14px",
              marginTop: "15px",
              width: "48%",
              minHeight: "90px",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#9ca3af",
                  margin: 0,
                }}
              >
                Cancelled Amount
              </p>

              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#000000",
                  margin: 0,
                }}
              >
                {isDataAllCard?.cancellation?.cancelled_amount_without_tax &&
                  (
                    isDataAllCard?.cancellation?.cancelled_amount_without_tax ||
                    0
                  ).toFixed(2)}
              </p>
            </div>

            <div>
              <div style={{ width: "26px", height: "26px" }}>
                <img
                  src={dashboardIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* TOTAL VALUES */}
        <div>
          <p
            style={{
              marginTop: "10px",
              fontFamily: "Open Sans",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "22px",
              color: "#222227",
            }}
          >
            Total
          </p>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "column",
              gap: 4,
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                background: "#F5F5F5",
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
                padding: "10px",
                width: "100%",
                borderRadius: "10px",
                marginBottom: "15px",
              }}
            >
              <p style={styles.label}>
                Cancellation Payment Revert to Customer
              </p>
              <p style={styles.value}>
                {isDataAllCard?.cancellation?.revert_to_customer &&
                  (
                    isDataAllCard?.cancellation?.revert_to_customer || 0
                  ).toFixed(2)}
              </p>
            </div>

            <div
              style={{
                background: "#F5F5F5",
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
                padding: "10px",
                width: "100%",
                borderRadius: "10px",
              }}
            >
              <p style={styles.label}>Cancellation Profit</p>
              <p style={styles.value}>
                {isDataAllCard?.cancellation?.cancellation_profit &&
                  (
                    isDataAllCard?.cancellation?.cancellation_profit || 0
                  ).toFixed(2)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cancellation;
